import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function diagramReducer(state = initialState.diagram, action) {
  let diagram = { ...state };

  switch (action.type) {
    case types.LOAD_DIAGRAM_SUCCESS:
      return action.content;

    case types.CREATE_DIAGRAM_SUCCESS:
      diagram = action.content;
      diagram.saved = true;
      return diagram;

    case types.UPDATE_DIAGRAM_SUCCESS:
      diagram = action.content;
      diagram.saved = true;
      return diagram;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/diagramReducer.js